import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BLOCK_MODULE_NAMESPACE, BLOCK_APARTMENT_SIDEBAR_GET_TICKETS } from '../../../../store/block';
import { ITicketParameter, ITicketListingViewModel, TicketParameter, TicketListingViewModel } from '../../../../models/ticket';
import { StateTypes, TicketTypes } from '../../../../common/enums';


const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component
class BlockSidebarWidgetTicket extends Vue {


  @BlockStore.Getter blockApartmentSidebarTickets: ITicketListingViewModel[];

  @BlockStore.Action(BLOCK_APARTMENT_SIDEBAR_GET_TICKETS)
  storeGetTickets: (payload: { storeKey?: string, ticketParameter: ITicketParameter }) => Promise<ITicketListingViewModel[]>;

  @Prop({ default: null, type: [String] })
  path: string;

  get tickets(): ITicketListingViewModel[] {
    return this.blockApartmentSidebarTickets;
  }
  redirectTo(ticket: any) {

    const generalChannel = ticket.channel_id;//ticket.channels.find(x => x.type === TicketTypes.Public) || {};

    return {
      path: `/ticket/${ticket.id}/channel/${generalChannel}`,
      params: { id: ticket.id, cid: generalChannel }
    }
  }
  mounted() {
    if (this.$route.params.id) {
      this.handleGetTickets();
    }
    this.$watch('$route.params', (n, o) => this.handleGetTickets());
  }
  handleGetTickets() {
    this.storeGetTickets({
      storeKey: 'blockApartmentSidebarTickets',
      ticketParameter: new TicketParameter({
        state: [StateTypes.Open, StateTypes.ReOpen, StateTypes.InProgress],
        block: [parseInt(this.$route.params.id)]
      })
    });
  }
}

export default BlockSidebarWidgetTicket;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-sidebar-widget-ticket/index.ts